let ONE_DAY = 1000 * 60 * 60 * 24;

export default {
    DEBUG: true,
    _id_: 0,

    clear(data) {
        data = data || {};
        let keys = Object.keys(data);
        keys.forEach(k => {
            let type = typeof data[k];
            switch (type) {
                case 'string':
                    data[k] = '';
                    break;
                case 'number':
                    data[k] = 0;
                    break;
                case 'boolean':
                    data[k] = false;
                    break;
                case 'object':
                    if (Array.isArray(data[k])) {
                        data[k] = [];
                    } else {
                        this.clear(data[k]);
                    }
                    break;
            }
        })
    },
    formatDate(date, formatStr) {
        try {
            if (!date) {
                return '';
            }
            if (typeof date == 'string') {
                date = new Date(Date.parse(date));
            }
            if (typeof date == 'number') {
                let t = new Date();
                t.setTime(date);
                date = t;
            }
            formatStr = formatStr || 'yyyy-MM-dd hh:mm:ss';
            let obj = {
                'M+': date.getMonth() + 1,
                'd+': date.getDate(),
                'h+': date.getHours(),
                'm+': date.getMinutes(),
                's+': date.getSeconds(),
                'q+': Math.floor((date.getMonth() + 3) / 3),
                'S': date.getMilliseconds()
            };
            if (/(y+)/.test(formatStr)) {
                formatStr = formatStr.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            for (let k in obj) {
                if (new RegExp('(' + k + ')').test(formatStr)) {
                    formatStr = formatStr.replace(
                        RegExp.$1,
                        (RegExp.$1.length == 1) ? (obj[k]) : (('00' + obj[k]).substr(('' + obj[k]).length))
                    );
                }
            }
            return formatStr;
        } catch (e) {

        }
        return '';
    },

    randomNum(minNum, maxNum) {
        switch (arguments.length) {
            case 1:
                return parseInt(Math.random() * minNum + 1, 10);
                break;
            case 2:
                return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
                break;
            default:
                return 0;
                break;
        }
    },

    //这是修复的代码
    getDiffDay(days) {
        const now = new Date();
        const daysAgo = parseInt(days, 10); // 解析天数参数
        const start = new Date(now);
        start.setDate(start.getDate() - daysAgo); // 计算days天前的日期
        return [start, now]; // 返回[startDate, now]数组
    }
}
